/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RunPhaseCheckoutPage {
  Simple = 'Simple',
  MultiUser = 'MultiUser'
}
